var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEcommerce(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e69e67",
    d: "M248.897 197.574H7.129a7.116 7.116 0 0 1-7.116-7.116V7.116A7.116 7.116 0 0 1 7.129 0h241.767a7.116 7.116 0 0 1 7.116 7.116v183.342a7.115 7.115 0 0 1-7.115 7.116z",
    className: "color6770e6 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6b58f",
    d: "M248.897 0H7.129A7.116 7.116 0 0 0 .013 7.116v7A7.116 7.116 0 0 1 7.129 7h241.768a7.116 7.116 0 0 1 7.116 7.116v-7A7.116 7.116 0 0 0 248.897 0z",
    className: "color8f95e6 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fca969",
    d: "M15.013 174.913V22.662A7.662 7.662 0 0 1 22.675 15h210.677a7.662 7.662 0 0 1 7.662 7.662v152.251a7.662 7.662 0 0 1-7.662 7.662H22.675a7.663 7.663 0 0 1-7.662-7.662z",
    className: "color69ebfc svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#c78858",
    d: "M98.151 197.574h60.948v38.435H98.151z",
    className: "color5861c7 svgShape"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e69e67",
    d: "M187.918 256H69.617c-5.52 0-9.995-4.475-9.995-9.995s4.475-9.995 9.995-9.995h118.301c5.52 0 9.995 4.475 9.995 9.995S193.438 256 187.918 256z",
    className: "color6770e6 svgShape"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#c78858",
    d: "M187.918 249H69.617c-4.287 0-7.933-2.704-9.353-6.495a9.943 9.943 0 0 0-.643 3.5c0 5.52 4.475 9.995 9.995 9.995h118.301c5.52 0 9.995-4.475 9.995-9.995a9.943 9.943 0 0 0-.643-3.5c-1.418 3.791-5.064 6.495-9.351 6.495z",
    className: "color5861c7 svgShape"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#e69e67",
    d: "M130.529 119.267H76.054c-4.202 0-7.461-3.672-6.961-7.844l6.054-50.552a2.283 2.283 0 0 1 2.266-2.011h51.757c1.156 0 2.129.864 2.266 2.011l6.054 50.552c.5 4.173-2.759 7.844-6.961 7.844z",
    className: "color6770e6 svgShape"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff8f2",
    d: "M119.23 72.455a3 3 0 0 1-3-3V53.516c0-7.135-5.805-12.939-12.939-12.939s-12.938 5.804-12.938 12.939v15.939a3 3 0 1 1-6 0V53.516c0-10.443 8.496-18.939 18.938-18.939 10.443 0 18.939 8.496 18.939 18.939v15.939a3 3 0 0 1-3 3z",
    className: "colorfff7f2 svgShape"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#f16900",
    d: "M178.103 119.267h-49.728c-5.41 0-9.555-4.81-8.756-10.161l5.41-36.199a2.402 2.402 0 0 1 2.375-2.047h51.669a2.4 2.4 0 0 1 2.375 2.047l5.41 36.199c.801 5.351-3.344 10.161-8.755 10.161z",
    className: "colord476e2 svgShape"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff8f2",
    d: "M153.239 105.584c-7.72 0-14-6.28-14-14v-11a3 3 0 1 1 6 0v11c0 4.411 3.589 8 8 8s8-3.589 8-8v-11a3 3 0 1 1 6 0v11c0 7.72-6.28 14-14 14z",
    className: "colorfff7f2 svgShape"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#f16900",
    d: "M166.077 159.384H89.949c-6.615 0-11.978-5.363-11.978-11.978 0-6.615 5.363-11.978 11.978-11.978h76.129c6.615 0 11.978 5.363 11.978 11.978 0 6.615-5.363 11.978-11.979 11.978z",
    className: "colord476e2 svgShape"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff8f2",
    d: "m177.28 163.651 9.823-1.829c1.223-.228 1.417-1.899.278-2.4l-29.103-12.812c-1.056-.465-2.131.611-1.667 1.667l12.812 29.103c.501 1.138 2.172.945 2.4-.278l1.694-9.1 9.761 9.337a2.865 2.865 0 0 0 1.985.797 2.874 2.874 0 0 0 1.987-4.949l-9.97-9.536z",
    className: "colorfff7f2 svgShape"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcommerce);
export default __webpack_public_path__ + "static/media/ecommerce.6560cbdbd5e7691ca5c08f68518ca2d4.svg";
export { ForwardRef as ReactComponent };